export default __webpack_public_path__ + "static/weedmats-d457f62f6a1b24368ad478f0493bb5f9.jpg";